import { customMessageTypeValues } from '../CustomMessage/constants'

export const triggerModeValues = {
  atTrigger: 'at_trigger',
  delayByDays: 'delay_by_days',
}

export const blockCustomMessageTypeOptions = [
  customMessageTypeValues.info,
  customMessageTypeValues.warning,
  customMessageTypeValues.error,
]
